module.exports = __webpack_public_path__ + "img/wechat.41dd3c80.jpg";